import { useState } from "react";
import { api } from "@/lib/api";
import { usePoll } from "@/hooks/usePoll";
import { fmtPrice, fmtPct, pnlClass } from "@/lib/format";
import { DataBadge } from "@/components/kit";

const PICK = ["BTCUSDT", "ETHUSDT", "EURUSD", "AAPL", "XAUUSD", "SPX"];

export const LiveStrip = () => {
  const [rows, setRows] = useState([]);
  usePoll(() => api.get("/market/assets").then((r) => setRows(r.data.filter((a) => PICK.includes(a.symbol)))).catch(() => {}), 5000);
  return (
    <div className="relative grid grid-cols-2 xl:grid-cols-3 gap-3" data-testid="login-live-strip">
      {rows.map((a) => (
        <div key={a.symbol} className="rounded-xl border border-white/10 bg-white/[0.04] p-3 backdrop-blur">
          <div className="flex items-center justify-between gap-2">
            <span className="text-xs font-semibold text-slate-300">{a.name}</span>
            <DataBadge type={a.data_type} testid={`login-strip-badge-${a.symbol}`} />
          </div>
          <div className="mt-2 flex items-baseline justify-between">
            <span className="num text-lg">{fmtPrice(a.price, a.decimals)}</span>
            <span className={`num text-xs ${pnlClass(a.change_pct)}`}>{fmtPct(a.change_pct)}</span>
          </div>
        </div>
      ))}
    </div>
  );
};
